import { Minus, Plus } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * Zoom buttons for pointer devices.
 *
 * Leaflet's own control is disabled on these maps because a pinch is the only
 * zoom gesture on a phone and the buttons cost a corner of a screen that is
 * mostly map on purpose. On a desktop the reverse is true: there is room, a
 * mouse has no pinch, and a map with no visible zoom affordance reads as
 * broken to anyone who does not think to scroll.
 *
 * Built here rather than re-enabling Leaflet's, whose default chrome does not
 * match anything else in the app.
 */
export function MapZoomControls({
  onZoomIn,
  onZoomOut,
  className,
}: {
  onZoomIn: () => void
  onZoomOut: () => void
  className?: string
}) {
  const button =
    'flex h-9 w-9 items-center justify-center text-secondary-text transition-colors hover:bg-subtle hover:text-primary-text'

  return (
    <div
      className={cn(
        'flex flex-col overflow-hidden rounded-lg border border-default bg-surface shadow-menu',
        className,
      )}
    >
      <button type="button" onClick={onZoomIn} className={button} aria-label="Zoom in">
        <Plus className="h-4 w-4" />
      </button>
      <span className="h-px bg-default" aria-hidden="true" />
      <button type="button" onClick={onZoomOut} className={button} aria-label="Zoom out">
        <Minus className="h-4 w-4" />
      </button>
    </div>
  )
}
